import { Button, Modal, Timeline } from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import GetPerfCycleTimelineApi from "../../../api/perf-cycles/GetPerfCycleTimelineApi";
import { useSelector } from "react-redux";

function PerfCycleTimelineModal(props) {
  const [data, setData] = useState();
  const perfCycleState = useSelector((state) => state.perfCycleState.value);

  useEffect(() => {
    getTimelineData();
  }, [props.visible]);

  async function getTimelineData() {
    const apiResponse = await GetPerfCycleTimelineApi(perfCycleState.id);
    if (apiResponse.success) {
      setData(apiResponse.data);
    }
  }

  function renderTimeline() {
    let output = [];

    data
      ?.sort((a, b) => {
        return moment(a.date) - moment(b.date);
      })
      .forEach((timeline) => {
        if (timeline.status === "Starting") {
          output.push(
            <Timeline.Item
              key={timeline?.date}
              color="green"
              dot={<CheckCircleFilled />}
            >
              <div>
                <div>Starting on</div>
                <div className="text-xs text-gray-400">
                  {moment(timeline.date).format("DD.MM.YYYY")}
                </div>
              </div>
            </Timeline.Item>
          );
        } else if (timeline.status === "Ending") {
          output.push(
            <Timeline.Item
              key={timeline?.date}
              color="green"
              dot={<CloseCircleFilled />}
            >
              <div>
                <div>Ending on</div>
                <div className="text-xs text-gray-400">
                  {moment(timeline.date).format("DD.MM.YYYY")}
                </div>
              </div>
            </Timeline.Item>
          );
        } else {
          output.push(
            <Timeline.Item key={timeline?.date} color="green">
              <div>
                <div>
                  {timeline.status +
                    (timeline.user ? "by " + timeline.user?.name : "")}
                </div>
                <div className="text-xs text-gray-400">
                  {moment(timeline.date).format("DD.MM.YYYY")}
                </div>
              </div>
            </Timeline.Item>
          );
        }
      });

    return output;
  }

  return (
    <Modal
      title={"Perf cycle timeline"}
      visible={props.visible}
      onCancel={props.handleCancel}
      footer={null}
    >
      <Timeline>{renderTimeline()}</Timeline>
      <div className="flex justify-between">
        <div></div>
        <Button onClick={props.handleCancel}>Ok</Button>
      </div>
    </Modal>
  );
}

export default PerfCycleTimelineModal;
